import { AtlassianProductHostingTypeValues as HostingType, MarketplaceAppPaymentModelValues, MarketplaceBillingCycleValues, MarketplacePartnerTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { useFeatureFlags } from '@atlassian/mpac-ui';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import React from 'react';
import Section, { SectionsWrapper } from "../../../Section";
import { useAppPricingPlan } from "./hooks";
import PaidViaPartnerPricing from "./PaidViaPartnerPricing/PaidViaPartnerPricing";
import PricingCalculatorSection from "./PricingCalculatorSection";
import PricingCalculatorSkeleton from "./PricingCalculatorSection/PricingCalculatorSkeleton";
import PricingFAQs from "./PricingFAQs";
import PricingHeading from "./PricingHeading";
import { BILLING_CYCLE_FOR_HOSTING, DEFAULT_ERROR_MESSAGE_PRICING_FAILED } from "./PricingTab.constants";
import PricingTiers from "./PricingTiers/PricingTiers";
import PricingTiersSkeleton from "./PricingTiers/PricingTiersSkeleton";
export const PaidViaAtlassianPricing = ({
  appId,
  hosting,
  mpacBaseUrl,
  onPricingCalculatorInstallCTAClick,
  compatibleProduct
}) => {
  const {
    displayPricingCalculator
  } = useFeatureFlags();
  const {
    annualPlan,
    monthlyPlan,
    loading
  } = useAppPricingPlan({
    appId,
    hosting,
    mpacBaseUrl
  });

  if (hosting === HostingType.Cloud && displayPricingCalculator) {
    if (monthlyPlan && annualPlan) {
      return /*#__PURE__*/React.createElement(PricingCalculatorSection, {
        annualPlan: annualPlan,
        monthlyPlan: monthlyPlan,
        onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
        compatibleProduct: compatibleProduct
      });
    } else if (loading) return /*#__PURE__*/React.createElement(PricingCalculatorSkeleton, null);
  } else {
    const applicableBillingCycle = BILLING_CYCLE_FOR_HOSTING[hosting];
    const pricingPlan = applicableBillingCycle === MarketplaceBillingCycleValues.Monthly ? monthlyPlan : annualPlan;

    if (pricingPlan) {
      return /*#__PURE__*/React.createElement(PricingTiers, {
        hosting: hosting,
        pricingPlan: pricingPlan,
        applicableBillingCycle: applicableBillingCycle
      });
    } else if (loading) return /*#__PURE__*/React.createElement(PricingTiersSkeleton, null);
  }

  return /*#__PURE__*/React.createElement("div", null, DEFAULT_ERROR_MESSAGE_PRICING_FAILED);
};

const PricingTab = ({
  appId,
  appKey,
  compatibleProducts,
  hasDataCenterVersion,
  hosting,
  learnMoreUrl,
  marketingLabels,
  partnerType,
  paymentModel,
  mpacBaseUrl,
  onPricingCalculatorInstallCTAClick
}) => {
  return /*#__PURE__*/React.createElement(SectionsWrapper, null, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(PricingHeading, {
    hosting: hosting
  }), paymentModel === MarketplaceAppPaymentModelValues.PaidViaPartner ? /*#__PURE__*/React.createElement(PaidViaPartnerPricing, {
    hosting: hosting,
    learnMoreUrl: learnMoreUrl
  }) : /*#__PURE__*/React.createElement(PaidViaAtlassianPricing, {
    appId: appId,
    hosting: hosting,
    mpacBaseUrl: mpacBaseUrl,
    onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
    compatibleProduct: compatibleProducts[0]
  })), /*#__PURE__*/React.createElement(PricingFAQs, {
    paymentModel: paymentModel,
    hosting: hosting,
    marketingLabels: marketingLabels,
    compatibleProducts: compatibleProducts,
    serverSubscriptionApp: MarketplaceAppUtils.isServerSubscriptionApp(appKey),
    hasDataCenterVersion: hasDataCenterVersion,
    byAtlassian: partnerType === MarketplacePartnerTypeValues.AtlassianInternal
  }));
};

export default PricingTab;